import Header from './Header';
import type { GroupSidebarTagsProps } from './interfaces';
import Tags from './Tags';
import { GroupTagsStateContainer } from './State.Container';

type Props
  = GroupSidebarTagsProps;

export default function GroupSidebarTags({ tags, onSave }: Props) {

  return (
    <GroupTagsStateContainer tags={tags} onSave={onSave}>
      <Header />
      <Tags />
    </GroupTagsStateContainer>
  );
}

export { GroupSidebarTags };